/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as crosstabActions from '../../../actions/crosstabActions';
import * as mmeUtils from '../../../util/MMEUtils';

class MMEFirstHeaderColumn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      crosstabTitle: '',
    };
  }

  UNSAFE_componentWillMount() {
    const { loadedCrosstabInfo } = this.props;
    const crosstabTitle = loadedCrosstabInfo.tableTitle;
    this.setState({ crosstabTitle });
    this.props.onValueChange(crosstabTitle);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // eslint-disable-next-line react/prop-types
    if (nextProps.tableData
      && (nextProps.loadedCrosstabInfo.title !== this.state.crosstabTitle)
    ) {
      this.setState({ crosstabTitle: nextProps.loadedCrosstabInfo.tableTitle });
      this.props.onValueChange(nextProps.loadedCrosstabInfo.tableTitle);
    }
  }

  handleCrosstabTitleChange = e => {
    if (e.target.value.length === 0 || e.target.value.trim()) {
      this.setState({ crosstabTitle: e.target.value });
    }
  };

  handleCrosstabTitleBlur = () => {
    const { crosstabTitle } = this.state;
    const { loadedCrosstabInfo } = this.props;
    this.props.crosstabActions.saveCrosstabTableTitle({
      ...loadedCrosstabInfo,
      title: crosstabTitle,
    });
  };

  handleSaveButton = () => {
    const { crosstabTitle } = this.state;
    this.props.handleCrosstabSaveButton(crosstabTitle);
  };

  onMMEGridViewSort = (key, columnIndex) => {
    let sortOrder = mmeUtils.SORT_DIRECTION.DESC;
    if (
      this.props.sortColumnIndex === columnIndex &&
      this.props.sortKey === key
    ) {
      switch (this.props.sortOrder) {
        case mmeUtils.SORT_DIRECTION.DESC:
          sortOrder = mmeUtils.SORT_DIRECTION.ASC;
          break;
        case mmeUtils.SORT_DIRECTION.ASC:
          sortOrder = mmeUtils.SORT_DIRECTION.NONE;
          break;
        default:
          sortOrder = mmeUtils.SORT_DIRECTION.DESC;
      }
    }
    this.props.onSort(sortOrder, key, columnIndex);
  };

  render() {
    const { rowHeader, observation, sortOrder, sortKey,
      sortColumnIndex, metricsList } = this.props;
    return (
      <div className="column left-column-width main-table-left-column">
        {this.props.showSave &&
          <div className="main-table-left-column-save" style={{ height: '44px' }}>
            <input
              type="text"
              placeholder={this.props.placeholder}
              disabled
            />
          </div>}
        {!this.props.showSave && <div className="main-table-left-column-save" />}
        <div className="main-table-left-column-filter" style={{ height: '30px' }}>
          <div className="mme-cell">
            {metricsList && metricsList.map((item, columnIndex) => (
              <div key={item.label} className={`mme-cell--item ${item.widthClass}`} title={item.label}>
                <button
                  type="button"
                  id={`${item.key}-header${columnIndex}`}
                  onClick={() => this.onMMEGridViewSort(item.key, columnIndex)}
                  style={{ textAlign: 'left' }}
                >{item.text}
                  {sortKey === item.key && sortOrder === 'desc' &&
                    sortColumnIndex === columnIndex && <i data-test="desc">▼</i>}
                  {sortKey === item.key && sortOrder === 'asc' &&
                    sortColumnIndex === columnIndex && <i data-test="asc">▲</i>}
                </button>
              </div>
            ))}
          </div>
          <div className="mme-cell-all">
            <div className="mme-cell-all-rows" title={rowHeader}>{rowHeader}</div>
            <div className="mme-cell-all-obs" title={observation}>{observation}</div>
          </div>
        </div>
      </div>
    );
  }
}

MMEFirstHeaderColumn.propTypes = {
  crosstabActions: PropTypes.shape({
    saveCrosstabTableTitle: PropTypes.func,
  }),
  handleCrosstabSaveButton: PropTypes.func,
  loadedCrosstabInfo: PropTypes.shape({
    tableTitle: PropTypes.string,
    title: PropTypes.string,
  }),
  onValueChange: PropTypes.func,
  showSave: PropTypes.bool,
  placeholder: PropTypes.string,
  rowHeader: PropTypes.string,
  observation: PropTypes.string,
  sortColumnIndex: PropTypes.number,
  sortOrder: PropTypes.string,
  sortKey: PropTypes.string,
  onSort: PropTypes.func,
  metricsList: PropTypes.arrayOf(PropTypes.shape({})),
};

function mapStateToProps(state) {
  return {
    loadedCrosstabInfo: state.crosstab.loadedCrosstabInfo,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    crosstabActions: bindActionCreators(crosstabActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps, null)(MMEFirstHeaderColumn);
